/**
 * @Description 紧急度
 */

import { FC, useEffect, useState, } from 'react';

import { FormItemProps, SelectProps } from 'antd';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
import { getCircleOptions } from '@/common/api/expandStore/expansiontask';

const FormEmergencyDegree:FC<{
  name: string;
  label?: string;
  rules?: any;
  placeholder?: string;
  selectConfig?: SelectProps;
  formConfig?: FormItemProps;
  required?: boolean;
}> = ({
  name,
  label,
  rules,
  placeholder,
  selectConfig,
  formConfig,
  required,
}) => {
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    getSelection();
  }, []);

  const getSelection = async () => {
    const options = await getCircleOptions();

    const emergencyData = options?.emergencyDegree.map((item) => ({
      label: item.name,
      value: item.id
    })) || [];
    setOptions(emergencyData);
  };

  return (
    <V2FormSelect
      required={required}
      name={name}
      label={label}
      options={options}
      rules={rules}
      placeholder={placeholder}
      config={{
        showSearch: true,
        ...selectConfig
      }}
      formItemConfig={formConfig}
    />
  );
};

export default FormEmergencyDegree;
